// extracted by mini-css-extract-plugin
module.exports = {"modal":"modal--C9J6R","buttons":"buttons--+eQe8"};